import { withContentParams } from "@features/shared/locale";
import { IHttpClient } from "@features/shared/request/model";

const SERVER_URL = `${process.env.NEXT_PUBLIC_API_URL}`;

export interface TruegateStartAnonRequest {
    email: string;
    subscriptionProductPlanId: string;
    currency?: string;
    subscriptionPlanCountry?: string;
    metadata?: Record<string, string>;
}

export interface TruegateStartAnonResponse {
    transactionId: string;
    widget: string;
}

export class TTruegateApi {
    constructor(private httpClient: IHttpClient) {}

    async getTruegatePlans() {
        // Content locale -> admin-authored plan names (plan_metadata).
        return await this.httpClient.do<import("../entities/payment").ITruegatePlan[]>(
            withContentParams(`${SERVER_URL}/payments/truegate/plans`)
        );
    }

    async startAnonPayment(data: TruegateStartAnonRequest) {
        return await this.httpClient.do<TruegateStartAnonResponse>(
            `${SERVER_URL}/payments/truegate/start-anon`,
            "POST",
            data
        );
    }
}
